<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：会员-等级管理-添加等级
  -->
  <div class="product-add">
    <el-form size="small" :model="form" ref="form">
      <div class="common-form">会员卡信息</div>
      <el-form-item label="会员等级" prop="card_num">
        <el-select v-model="form.grade_id" placeholder="请选择会员等级">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name"  :value="item.grade_id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="会员卡数量" prop="card_num" :rules="[{required: true,message: '请输入会员卡数量 '}]">
        <el-input v-model="form.card_num" class="max-w460" type="number"></el-input>
      </el-form-item>
      <el-form-item label="会员卡前缀" prop="card_prefixes" :rules="[{required: true,message: '请输入会员卡前缀 '}]">
        <el-input v-model="form.card_prefixes" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="会员有效期" prop="expiry_date" :rules="[{required: true,message: '请输入会员有效期 '}]">
        <el-input v-model="form.expiry_date" class="max-w460" type="number"><template slot="append">天</template></el-input>
      </el-form-item>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="add" :loading="loading">确认</el-button>
    </div>
    </el-form>
  </div>
</template>

<script>
import GradeCardApi from '@/api/gradecard.js';
  export default {
    components: {
    },
    data() {
      return {
        form: {
          grade_id: '',
          product_name: '',
          product_image: [],
          /*满值*/
          card_num: '',
          card_prefixes: '',
        },
        gradeList: [],
        /*是否正在加载*/
        loading: false,
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /*获取列表*/
      getTableList() {
        let self = this;
        GradeCardApi.gradeList({}, true)
          .then(data => {
            self.loading = false;
            self.gradeList = data.data.gradeList;
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },

      /*添加*/
      add() {
        let self = this;
        let params = this.form;
        self.loading = true;
        GradeCardApi.addGradeCard(params, true).then(data => {
            self.loading = false;
            self.$message({
              message: data.msg,
               type: 'success'
            });
            self.$router.push('/plus/gradecard/index');
          })
          .catch(error => {
            self.loading = false;
          });
      },


    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/gradecard/add.vue